<script lang="ts">
	import { PUBLIC_PATH } from '$env/static/public';

	export let introText: string[] = [];
	export let sections: { id?: string; title: string; paragraphs: string[] }[] = [];
</script>

<section
	aria-label="Terms and Conditions Content"
	class="relative overflow-hidden mx-auto max-w-8xl px-padding_lg py-8 lg:px-20"
>
	<!-- Background grid -->
	<div
		class="pointer-events-none absolute inset-0 bg-repeat opacity-[0.26]"
		style="background-image: url('{PUBLIC_PATH}/images/grid-line-blue.svg');"
	></div>

	<!-- Intro Paragraphs -->
	<div class="mb-padding_xxxlg flex mb-6 flex-col gap-padding_sm">
		{#each introText as intro, idx}
			<p
				class="tracking-[0.0015rem] body_small {idx
					? 'mt-padding_xsm'
					: ''} text-body lg:body_large"
			>
				<!-- eslint-disable-next-line svelte/no-at-html-tags -->
				{@html intro}
			</p>
		{/each}
	</div>

	<div class="mb-6 flex flex-col gap-padding_xlg">
		{#each sections as section}
			<div id={section.id}>
				<h2 class="text-xl lg:text-3xl font-semibold text-black-key font-barlow">
					{section.title}
				</h2>

				{#each section.paragraphs as paragraph}
					<!-- Use margin top for any paragraph after the first one -->
					<p class="body_small text-body lg:body_large">
						<!-- eslint-disable-next-line svelte/no-at-html-tags -->
						{@html paragraph}
					</p>
				{/each}
			</div>
		{/each}
	</div>
</section>
